import { ChangeDetectorRef, Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { TrainingsTrackerService } from '../trainings_tracker/trainings_tracker_header/trainings_tracker.service';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-log-hours-dialog',
  templateUrl: './log-hours-dialog.component.html',
  styleUrls: ['./log-hours-dialog.component.css']
})
export class LogHoursDialogComponent {

  percentage = 70;

  statusOptions: any = ['New', 'In Progress', 'Completed', 'Delayed'];

  isMentor: boolean;

  selectedStatus: string = 'In Progress';

  summaryDetails: any = {};

  originalSummaryDetails: any = {};

  constructor(
    private dialogRef: MatDialogRef<LogHoursDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private cdr: ChangeDetectorRef,
    private trainingsTrackerService: TrainingsTrackerService,
    private toastr: ToastrService,
  ) {
    this.isMentor = this.data.isMentor;
    this.originalSummaryDetails = this.data.details;
    this.summaryDetails = JSON.parse(JSON.stringify(this.data.details));
  }

  onCancel() {
    this.dialogRef.close();
  }

  updateTraining() {
    if (this.isMentor) {
      const params = {
        "mentorId": this.summaryDetails.mentorId,
        "menteeId": this.summaryDetails.menteeId,
        "trainingId": this.summaryDetails.trainingId,
        "menteeLogHours": `${this.summaryDetails.mentorHours}`,
        "completedPercentage": this.summaryDetails.completedPercentage,
        "status": this.summaryDetails.status
      }
      this.trainingsTrackerService.updateMentorLogHours(params).subscribe((res) => {
        this.toastr.success('Training updated successfully');
        this.dialogRef.close(true);
      }, (err) => { 
        this.toastr.error('Error updating training');
      });
    } else {
      const params ={
        "mentorId": this.summaryDetails.mentorId,
        "menteeId": this.summaryDetails.menteeId,
        "trainingId": this.summaryDetails.trainingId,
        "menteeLogHours": `${this.summaryDetails.hoursSpent}`,
        "completedPercentage": this.summaryDetails.completedPercentage,
        "status": this.summaryDetails.status
      };
      this.trainingsTrackerService.updateMenteeLogHours(params).subscribe((res) => {
        this.toastr.success('Training updated successfully');
        this.dialogRef.close(true);
      }, (err) => {
        this.toastr.error('Error updating training');
      });
    }
  }

}
